import React from 'react';
import * as S from './styles';

interface Props {
  title?: string | React.ReactNode;
  icon?: React.ReactNode;
  description?: string
}

export const ModalTab: React.FC<Props> = ({ title, icon, description }) => {
  return (
    <S.ModalTab title={description}>
      <S.TitleSlot>
        {icon} <S.Title>{title}</S.Title>
      </S.TitleSlot>
    </S.ModalTab>
  );
};
